import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../../store";
import { RootState } from "../../rootReducer";
import { ILoginData } from "./Login";
import Firebase from "../../../api/Firebase";
import { ISignUpData } from "./SignUp";

const initialState: IUserState = {
    userId: '',
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        authSuccess: (state, { payload }: PayloadAction<string>) => {
            state.userId = payload;
            state.errors = undefined;
        },
        authFailure: (state, { payload }: PayloadAction<IAuthError>) => {
            state.userId = '';
            state.errors = payload;
        },
    }
});

export const { authSuccess, authFailure } = userSlice.actions;
export const userSelector = (state: RootState) => state.user;

export const checkSessionStorage = (dispatch: AppDispatch) => {
    const storedId = window.sessionStorage.getItem('userId');
    if(storedId !== null) {
        dispatch(authSuccess(storedId));
    }
};

export const login = (data: ILoginData) => {
    return async (dispatch: AppDispatch) => {

        try {
            const userData = await Firebase.login(data.email, data.password);
            window.sessionStorage.setItem('userId', userData.user!.uid);
            dispatch(authSuccess(userData.user!.uid));
        } catch (err) {
            dispatch(authFailure(err));
        }
    }
};

export const logout = () => {
    return async (dispatch: AppDispatch) => {

        try {
            await Firebase.logout();
            window.sessionStorage.removeItem('userId');
            dispatch(authSuccess(''));
        } catch (err) {
            dispatch(authFailure(err));
        }
    }
};

export const signUp = (data: ISignUpData) => {
    return async (dispatch: AppDispatch) => {

        if(data.password === data.confirm) {
            try {
                const userData = await Firebase.signUp(data.email, data.password);
                window.sessionStorage.setItem('userId', userData.user!.uid);
                dispatch(authSuccess(userData.user!.uid));
            } catch (err) {
                dispatch(authFailure(err));
            }
        } else {
            const noMatch: IAuthError = {
                code: 400,
                message: 'Passwords do not match',
                errors: []
            }
            dispatch(authFailure(noMatch));
        }
    }
}

interface IUserState {
    userId: string;
    errors?: IAuthError;
}

interface IAuthErrorDetails {
    domain: string;
    message: string;
    reason: string;
}

export interface IAuthError {
    code: number;
    errors: IAuthErrorDetails[];
    message: string;
}
